import React, { Suspense, useEffect } from 'react'
import { Switch, useLocation, Route } from 'react-router-dom'
import { Layout, Spin } from 'antd'

import { useSelector, shallowEqual, useDispatch } from 'react-redux'

import { routes } from '../router'
import AuthRute from '../components/AuthRute'
import NotFound from '../pages/NotFound'
import * as API from '../servers/meta'

import styles from './layout.module.scss'
const { Content } = Layout

type IBreadcrumb = {
  path: string
  breadcrumbName: string
}

type Props = {
  path: any
  exact: any
  component: any
}
const ContentPage: React.FC = () => {
  const location = useLocation()
  const pathname = location.pathname
  const needLogin = pathname !== '/login'
  const { token } = useSelector((state: any) => {
    return {
      token: state.user.token,
    }
  }, shallowEqual)

  const {
    meta: { update },
  } = useDispatch()

  const renderRoute = () => {
    return (
      <Suspense
        fallback={
          <div className={styles.page_fallback}>
            <Spin className={styles.spin} size="large" />
          </div>
        }
      >
        <Switch>
          {routes.map((route: Props) => {
            return <AuthRute {...route} />
          })}
          <Route component={NotFound} />
        </Switch>
      </Suspense>
    )
  }

  useEffect(() => {
    if (token && needLogin) {
      API.getMetaData().then((res: any) => {
        update(res)
      })
    }
  }, [token, needLogin, update])

  return (
    <Layout className={styles.sitelayout} id="layout-content-main">
      {/* <Breadcrumb itemRender={itemRender} routes={breadcrumbs} /> */}
      {/* <PageHeader breadcrumb={{ routes: breadcrumbs }} /> */}
      <Content className={styles.contentpane}>
        <div className={[styles.main, needLogin ? '' : styles.pageloading].join(' ')}>{renderRoute()}</div>
      </Content>
    </Layout>
  )
}

export default ContentPage
